import { render, staticRenderFns } from "./JudgesList.vue?vue&type=template&id=04adf2b0&scoped=true"
import script from "./JudgesList.vue?vue&type=script&lang=js"
export * from "./JudgesList.vue?vue&type=script&lang=js"
import style0 from "./JudgesList.vue?vue&type=style&index=0&id=04adf2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04adf2b0",
  null
  
)

export default component.exports